(function (root) {
  if (root.BlusafeCompatibility && root.BlusafeCompatibility.evaluate) return;

  var rules = null;
  var PHOTO_STATUS = 'photo_required';
  var PROBABLY_STATUS = 'probably_compatible';
  var COMPATIBLE_STATUS = 'compatible';
  var NOT_STATUS = 'not_compatible';

  function clone(value) {
    return JSON.parse(JSON.stringify(value || null));
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isUnknown(value) {
    var normalized = normalize(value);
    return normalized === 'unknown' || normalized === 'not_sure' || normalized === 'unsure' || normalized === 'not-sure';
  }

  function ruleSet(customRules) {
    return customRules || rules || {};
  }

  function productRules(customRules) {
    return (ruleSet(customRules).products || []).slice();
  }

  function findRule(family, customRules) {
    family = normalize(family);
    return productRules(customRules).filter(function (product) {
      return normalize(product.family) === family;
    })[0] || null;
  }

  function allFamilies(customRules) {
    return productRules(customRules).map(function (product) {
      return normalize(product.family);
    });
  }

  function inferFamilyFromHandle(handle, liveProducts, customRules) {
    var normalizedHandle = normalize(handle);
    var exact = (liveProducts || []).filter(function (product) {
      return normalize(product.handle) === normalizedHandle;
    })[0];
    if (exact && exact.family) return normalize(exact.family);

    if (!normalizedHandle) return '';
    if (normalizedHandle.indexOf('mirage') !== -1 || normalizedHandle.indexOf('padlock') !== -1) return 'excluded';
    if (normalizedHandle.indexOf('breeze') !== -1) return 'breeze';
    if (normalizedHandle.indexOf('contour') !== -1) return 'contour';
    if (normalizedHandle.indexOf('cloud') !== -1) return 'cloud';
    if (normalizedHandle.indexOf('apollo') !== -1) return 'apollo';
    if (normalizedHandle.indexOf('yunity') !== -1) return 'yunity';
    if (normalizedHandle.indexOf('origin') !== -1 || normalizedHandle.indexOf('osp') !== -1) return 'osp_legacy';

    return allFamilies(customRules).filter(function (family) {
      return normalizedHandle.indexOf(family.replace('_legacy', '')) !== -1;
    })[0] || '';
  }

  function familyForLockType(lockType, customRules) {
    var map = ruleSet(customRules).lockTypeFamilyMap || {};
    return normalize(map[lockType] || '');
  }

  function publicProductFromRule(rule, liveProducts, productHandle) {
    if (!rule) return null;
    var family = normalize(rule.family);
    var exact = (liveProducts || []).filter(function (product) {
      return normalize(product.family) === family && normalize(product.handle) === normalize(productHandle);
    })[0];
    var familyProduct = (liveProducts || []).filter(function (product) {
      return normalize(product.family) === family && (product.handle || product.url);
    })[0];
    var live = exact || familyProduct || {};

    return {
      family: family,
      title: live.title || rule.title || family,
      handle: live.handle || '',
      url: live.url || rule.url || '',
      image: live.image || '',
      price: live.price || '',
      available: typeof live.available === 'boolean' ? live.available : null,
      variantId: live.variantId || null,
      expectedLockType: rule.expectedLockType || '',
      specStatus: rule.specStatus || '',
      warnings: (rule.warnings || []).slice()
    };
  }

  function baseResult(status) {
    return {
      status: status,
      recommendedProducts: [],
      rejectedProducts: [],
      reasons: [],
      missingChecks: [],
      warnings: [],
      accessoryRecommendations: []
    };
  }

  function hasAnyUnknownAnswer(answers) {
    return Object.keys(answers || {}).some(function (key) {
      return isUnknown(answers[key]);
    });
  }

  function addSpecWarnings(result, rule) {
    if (!rule) return;
    (rule.warnings || []).forEach(function (warning) {
      if (result.warnings.indexOf(warning) === -1) result.warnings.push(warning);
    });
    if (rule.specStatus === 'needs_confirmation') {
      result.missingChecks.push('Confirm final door thickness, backset and hardware measurements before treating this as authoritative.');
    }
  }

  function evaluateBreeze(answers, rule) {
    var result = baseResult(COMPATIBLE_STATUS);

    if (answers.usage === 'external') {
      result.status = NOT_STATUS;
      result.reasons.push('Breeze is for internal doors, not exterior doors.');
      return result;
    }

    if (answers.standard_latch === 'no') {
      result.status = NOT_STATUS;
      result.reasons.push('Breeze needs a standard internal latch.');
      return result;
    }

    if (answers.door_thickness_mm === 'under_35' || answers.door_thickness_mm === 'over_45') {
      result.status = NOT_STATUS;
      result.reasons.push('Breeze Plus is confirmed for 35-45 mm internal doors.');
      return result;
    }

    if (answers.backset_mm === 'other') {
      result.status = PROBABLY_STATUS;
      result.missingChecks.push('Breeze Plus is confirmed for 60 mm or 70 mm backsets. Check your latch before ordering.');
    }

    if (!answers.door_thickness_mm || !answers.backset_mm) {
      result.status = PROBABLY_STATUS;
      result.missingChecks.push('Confirm door thickness and backset before ordering.');
    }

    result.reasons.push('Your answers match an internal door with a standard latch.');
    result.reasons.push('Breeze Plus is confirmed for 35-45 mm doors and 60/70 mm backsets.');
    addSpecWarnings(result, rule);
    return result;
  }

  function evaluateContour(answers, rule) {
    var result = baseResult(PROBABLY_STATUS);

    if (answers.usage === 'internal') {
      result.status = NOT_STATUS;
      result.reasons.push('Contour is for external latch-style doors. An internal latch door is a Breeze path.');
      return result;
    }

    if (answers.latch_style === 'deadbolt' || answers.latch_style === 'multipoint') {
      result.status = NOT_STATUS;
      result.reasons.push('Contour is for latch-style handle doors, not deadbolts or multipoint lift-handle doors.');
      return result;
    }

    result.reasons.push('Your answers match an external latch-style handle door.');
    addSpecWarnings(result, rule);
    return result;
  }

  function evaluateCloud(answers, rule) {
    var result = baseResult(PROBABLY_STATUS);

    if (answers.deadbolt_standard === 'latch' || answers.deadbolt_standard === 'multipoint') {
      result.status = NOT_STATUS;
      result.reasons.push('Cloud is for standard deadbolt doors, not latch handles or multipoint systems.');
      return result;
    }

    result.reasons.push('Your answers match a standard deadbolt door.');
    addSpecWarnings(result, rule);
    return result;
  }

  function evaluateApolloLike(answers, rule) {
    var result = baseResult(rule && rule.specStatus === 'needs_confirmation' ? PROBABLY_STATUS : COMPATIBLE_STATUS);

    if (answers.lift_to_lock === 'normal_handle' || answers.lift_to_lock === 'pull_bar') {
      result.status = NOT_STATUS;
      result.reasons.push('This product needs a lift-handle multipoint setup.');
      return result;
    }

    if (answers.multipoint_strip === 'no') {
      result.status = NOT_STATUS;
      result.reasons.push('A visible multipoint strip is expected for this lock family.');
      return result;
    }

    if (answers.smooth_locking === 'no') {
      result.status = PROBABLY_STATUS;
      result.missingChecks.push('The door should lock smoothly before fitting a smart handle. Fix alignment or send photos first.');
    }

    if (answers.remote_control === 'yes') {
      result.accessoryRecommendations.push({
        type: 'gateway',
        handle: 'blusafe-ttlock-bluetooth-bridge-wifi-fingerprint-password-smart-electronic-door-lock-home-bridge-ttlock-app-control-hub',
        title: 'TTLock Wi-Fi bridge',
        reason: 'Recommended for remote lock/unlock and access management away from the door.'
      });
    }

    result.reasons.push('Your answers match a lift-handle multipoint door.');
    addSpecWarnings(result, rule);
    return result;
  }

  function evaluateYunity(answers, rule, recommendedProduct) {
    var result = baseResult(COMPATIBLE_STATUS);

    if (answers.pull_bar === 'normal_handle' || answers.pull_bar === 'lift_handle') {
      result.status = NOT_STATUS;
      result.reasons.push('Yunity is for pull-bar, auto-lock, slam-shut or key-winding multipoint doors.');
      return result;
    }

    if (answers.slam_shut_type === 'no') {
      result.status = NOT_STATUS;
      result.reasons.push('Yunity needs the pull-bar or slam-shut style of multipoint setup.');
      return result;
    }

    result.reasons.push('Your answers match a pull-bar or slam-shut multipoint door.');
    addSpecWarnings(result, rule);

    if (rule && rule.availabilitySensitive && recommendedProduct && recommendedProduct.available !== true) {
      result.status = PROBABLY_STATUS;
      result.warnings.push('This looks like the right product family, but Yunity is not currently available to buy as a normal result.');
      result.missingChecks.push('Send photos or use the back-in-stock route before choosing an alternative.');
    }

    return result;
  }

  function evaluateFamily(family, answers, rule, recommendedProduct) {
    if (family === 'breeze') return evaluateBreeze(answers, rule);
    if (family === 'contour') return evaluateContour(answers, rule);
    if (family === 'cloud') return evaluateCloud(answers, rule);
    if (family === 'apollo' || family === 'osp_legacy') return evaluateApolloLike(answers, rule);
    if (family === 'yunity') return evaluateYunity(answers, rule, recommendedProduct);

    var result = baseResult(PHOTO_STATUS);
    result.reasons.push('We need photos to confirm this lock type.');
    return result;
  }

  function buildRejectedProducts(currentFamily, targetFamily, liveProducts, customRules, productHandle) {
    if (!currentFamily || currentFamily === targetFamily || currentFamily === 'excluded') return [];
    var rule = findRule(currentFamily, customRules);
    var product = publicProductFromRule(rule, liveProducts, productHandle);
    return product ? [product] : [];
  }

  function evaluate(input) {
    input = input || {};
    var customRules = input.rules || rules;
    var liveProducts = (input.products || []).filter(Boolean);
    var answers = clone(input.answers || {}) || {};
    var productHandle = input.productHandle || '';
    var mode = input.mode || 'main';
    var currentFamily = normalize(answers.currentFamily || inferFamilyFromHandle(productHandle, liveProducts, customRules));

    if (currentFamily === 'excluded') {
      var excluded = baseResult(PHOTO_STATUS);
      excluded.reasons.push('Mirage padlocks are excluded from the door compatibility checker.');
      return excluded;
    }

    if (hasAnyUnknownAnswer(answers)) {
      var unsure = baseResult(PHOTO_STATUS);
      unsure.reasons.push('A photo review is the safest route when any key detail is unclear.');
      return unsure;
    }

    var lockType = answers.lockType || (findRule(currentFamily, customRules) || {}).expectedLockType || '';
    var targetFamily = familyForLockType(lockType, customRules);

    if (mode === 'mini' && currentFamily === 'osp_legacy' && targetFamily === 'apollo') {
      targetFamily = 'osp_legacy';
    }

    if (!targetFamily) {
      var noTarget = baseResult(PHOTO_STATUS);
      noTarget.reasons.push('We need photos to identify the lock type before recommending a product.');
      return noTarget;
    }

    if (mode === 'mini' && currentFamily && currentFamily !== targetFamily) {
      var mismatch = baseResult(NOT_STATUS);
      var targetRule = findRule(targetFamily, customRules);
      var targetProduct = publicProductFromRule(targetRule, liveProducts, productHandle);
      mismatch.recommendedProducts = targetProduct ? [targetProduct] : [];
      mismatch.rejectedProducts = buildRejectedProducts(currentFamily, targetFamily, liveProducts, customRules, productHandle);
      mismatch.reasons.push('Based on your answers, this product is not the right lock family for your door.');
      if (targetProduct) mismatch.reasons.push(targetProduct.title + ' is a better family match.');
      return mismatch;
    }

    var rule = findRule(targetFamily, customRules);
    var product = publicProductFromRule(rule, liveProducts, productHandle);
    var result = evaluateFamily(targetFamily, answers, rule, product);
    result.recommendedProducts = product && result.status !== NOT_STATUS ? [product] : [];
    result.rejectedProducts = buildRejectedProducts(currentFamily, targetFamily, liveProducts, customRules, productHandle);
    return result;
  }

  root.BlusafeCompatibility = {
    setRules: function (nextRules) {
      rules = nextRules || null;
      return rules;
    },
    getRules: function () {
      return rules;
    },
    evaluate: evaluate,
    familyForLockType: function (lockType) {
      return familyForLockType(lockType, rules);
    },
    inferFamilyFromHandle: function (handle, liveProducts) {
      return inferFamilyFromHandle(handle, liveProducts || [], rules);
    }
  };
})(typeof window !== 'undefined' ? window : globalThis);
